
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { DepartmentResponse } from "../../models/dtos";

export const departmentsApi = createApi({
  reducerPath: 'departmentsApi',
  baseQuery: baseAuthQuery('Departments'),
  tagTypes: ['Department'],
  endpoints: (builder) => ({
    getDepartments: builder.query<ApiResponse<DepartmentResponse[]>, void>({
      query: () => "",
      providesTags: ['Department'],
    }),
    getDepartmentById: builder.query<ApiResponse<DepartmentResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Department'],
    }),
    updateDepartment: builder.mutation<ApiResponse<DepartmentResponse>, Partial<DepartmentResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Department'],
    }),
    deleteDepartment: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Department'],
    }),
  }),
});
